import root from 'window-or-global';

export default function () {
    /**
     * Enum for URLs for the API endpoints.
     *
     */
    let context = '';
    if (root.appContext && root.appContext !== '/') {
        context = root.appContext;
    }

    if (!root.location.origin) {
        const port = root.location.port ? `:${root.location.port}` : '';
        root.location.origin = `${root.location.protocol}//${root.location.hostname}${port}`;
    }
    const origin = root.location.origin + context;

    const URL = {
        ORIGIN: `${origin}`,
        GET_AFFILIATE_SLUG_OPTIONS: `${origin}/api/get-affiliate-slug-options`,
        GET_INFLUENCER_PROFILE: `${origin}/api/get-affiliate-profile`,
        CREATE_INFLUENCER_PROFILE: `${origin}/api/create-affiliate-account`,
        UPDATE_INFLUENCER_PROFILE: `${origin}/api/update-affiliate-account`,
        UPDATE_PAYOUT_TYPE: `${origin}/api/update-payout-type`,

        GET_PAYOUT_ACCOUNT: `${origin}/api/get-payout-account`,
        CREATE_PAYOUT_ACCOUNT: `${origin}/api/create-payout-account`,
        UPDATE_PAYOUT_ACCOUNT: `${origin}/api/update-payout-account`,

        GET_TAX_INFO: `${origin}/api/get-tax-info`,
        CREATE_TAX_INFO: `${origin}/api/create-tax-info`,
        UPDATE_TAX_INFO: `${origin}/api/update-tax-info`,
        ACTIVE_TAX_INFO: `${origin}/api/active-tax-info`,
        GET_TAX_INTERVIEW: `${origin}/api/get-tax-interview`,
        GET_TAX_PROFILE: `${origin}/api/get-tax-profile`,
        GET_TAX_RECORD: `${origin}/api/get-tax-record`,
        UPDATE_TAX_RECORD: `${origin}/api/update-tax-record`,
        RETAKE_INTERVIEW: `${origin}/api/retake-tax-interview`,
        GET_BALANCE_PAYABLE: `${origin}/api/get-balance-payable`,
        GET_RECORD_EMAIL: `${origin}/api/get-record-email`,
        GET_UPDATE_AVAILABLE: `${origin}/api/get-update-available`,
        GET_CONSENT: `${origin}/api/get-payout-consent`,
        REFRESH_TAX_RECORD: `${origin}/api/refresh-tax-record`,
        CONSENT_FOR_PAYMENT: `${origin}/api/consent-for-payment`,

        GET_ORGANIZATIONS: `${origin}/api/get-organizations`,

        UPLOAD_W9FORM: `${origin}/api/upload-w9form`,
        CHECK_W9FORM: `${origin}/api/check-w9form`,

        GET_DASHBOARD_DATA: `${origin}/api/get-dashboard-data`,
        GET_EARNINGS_DATA: `${origin}/api/get-earnings-data`,

        CREATE_RESEND_EMAIL_VERIFICATION: `${origin}/api/resend-email-verification`,
        UPDATE_TWO_FACTOR_AUTHENTICATION: `${origin}/api/update-two-factor-authentication`,

        GET_CHECK_EMAIL_VERIFICATION: `${origin}/api/check-email-verification`,

        GET_ACCOUNT_SOCIAL_LINKS: `${origin}/api/get-linked-social-accounts`,

        GET_CODE_OF_CONDUCT: `${origin}/api/get-eula/affiliate`,
        GET_AFFILIATE_AGREEMENT: `${origin}/api/get-eula/affiliate_agreement`,

        GET_PAYOUT_PERIODS: `${origin}/api/get-payout-periods`,
        GET_PAYOUT_REPORT: `${origin}/api/get-payout-report`,
        DOWNLOAD_PAYOUT_REPORT: `${origin}/api/download-payout-report`,

        // Same API for now. The body just differs (EULA ID)
        ACCEPT_CODE_OF_CONDUCT: `${origin}/api/update-affiliate-agreement`,
        ACCEPT_AFFILIATE_AGREEMENT: `${origin}/api/update-affiliate-agreement`,

        GET_APP_CONFIG: `${origin}/api/get-app-config`,

        GET_OVERVIEW_DATA: `${origin}/api/get-overview`,

        GET_PAGE: `${origin}/api/get-page`
    };

    return URL;
}
